import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
@Component({
    selector: 'app-cases-item',
    standalone: true,
    imports: [MatTooltipModule],
    templateUrl: './case-item.component.html',
    styles: [''],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaseItemComponent {

    @Input('title') title;
    @Input('content') content;
    @Input('tooltip') tooltip;

    constructor() {
    }
}